import React, { Component } from "react";
import Wrp from '../../../../../../hoc/Wrp/Wrp';
import moment from 'moment';
import ReminderOption from "./ReminderOption";
import RepeatOption from "./RepeatOption";
import {ReminderDisplayValue} from './ReminderFunction';
import 'moment-timezone';
import {getUserTimeZone} from '../../../../../../Utils/UserFunctions';
import {isSet} from '../../../../../../Utils/CommonFunctions';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Modal from "../../../../../UI/Modal";
import DrillDown from "../../../../../../Components/DrillDown";
import Buttons from "../../../../../../Components/UI/Buttons";
import { updateLookupFieldDetails,setFormulaFieldDetails } from "../../../../../../store/actions/StepsFlowAction";
import {getVariableDisplayValue} from '../../../../../../Containers/StepsFlowContainer/StepsFunction';

class StepsFormatTag extends Component {    
    render() {
        const {handlerObj,reminderJson} = this.props;
        const btnGroup = [{ 
            isButtonGroup:true,
            className:'input-group-text pl-2 pr-2',
            style:{},
            list:[
            {
                href:"",
                attributes:{
                className:"border-default dropdown-toggle  dropdown-menu-right hidden-caret",
                'data-toggle':'dropdown',
                'aria-expanded':'false'
                },
                name:"",
                svgIcon:'EllipsisV',
                children:{
                    attributes:{
                    className:"dropdown-menu dropdown-menu-right"
                    },
                    style:{
                    position:'absolute',
                    transform: 'translate3d(-44px, 33px, 0px)', 
                    top: '0px',
                    left: '0px', 
                    willChange: 'transform'
                    },
                    buttonList:[{
                        name:'Add Formula',
                        attributes:{
                            className:'dropdown-item'
                        },
                        clickHandler:()=>this.props.setFormulaFieldDetails({
                            value:'',//(isSet(myArrayConst,[]).length)>0?isSet(myArrayConst[0],{}).value:'',
                            conValue:[{
                                name:'',
                                data_id:'',
                                is_loop:false,
                                value:'',
                                is_window_field:false,
                                is_variable_or_constant:false,
                                is_expression:true
                            }],
                            itmValIndex:0,
                            drillDownOptions:this.props.item.lookupFieldsData.lookupFields.drillDownOptions,
                            //updateValuesChangeHandler:(itmIndex,key,val)=>{console.log('val',val); props.updateLookupFieldDetails(item.id,val)},
                            //updateValuesChangeHandler:(val)=>props.updateLookupFieldDetails(item.id,val),
                            updateValuesChangeHandler:(val)=>this.props.actionChangeHandlerForFormula({},handlerObj.field_name,val,true,true),
                            conIndex:0,
                        },true)
                    }]
                    }
                }
            ]
        }]

        let getVal = isSet(reminderJson[handlerObj.field_name],[]).length>0?reminderJson[handlerObj.field_name][0].value:''; 
        let selectedValueForDrill = getVariableDisplayValue(this.props.item.lookupFieldsData.lookupFields.drillDownOptions,getVal,{});

        return (
            <div className='input-group-append cursor-pointer'>
                 <DrillDown 
                    drillId={"drill_"+this.props.item.id} 
                    selectedValue={isSet(selectedValueForDrill,[]).length>0?selectedValueForDrill:[]} 
                    hocClass='input-group-text'
                    fieldDetails={this.props.item.lookupFieldsData.lookupFields.drillDownOptions} 
                    selectHandler={(val)=>this.props.actionChangeHandler({},handlerObj.field_name,val,true,true)}
                    isConditionApplied={true}
                    isCustomChildren={true} >
                <span className="input-group-text" style={{height:'100%',display:'block',border:'0px'}}>
                    <i className="fas fa-search primary_color"></i>
                </span>
                </DrillDown>
                <Buttons buttonList={btnGroup} />
            </div>
        );
    }
};

const mapStateToProps = (state,props) => { 
    return {
        lookupFieldsData:state.StepsFlowReducer.lookupFieldsData,
        valuesObject:state.StepsFlowReducer.lookupFieldsData.valuesObject,
        //  formulaFieldData:state.StepsFlowReducer.formulaFieldData
    };
  }

const mapDispatchToProps = dispatch => {
    return {
      setFormulaFieldDetails:(obj,bool)=>dispatch(setFormulaFieldDetails(obj,bool)),
      updateLookupFieldDetails:(obj,val)=>dispatch(updateLookupFieldDetails(obj,val)),
    };
}
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(StepsFormatTag);

//export default StepsFormatTag;